import { NativeBiometric, BiometryType } from '@capgo/capacitor-native-biometric';

export const isBiometricsAvailable = async () => {
  try {
    const result = await NativeBiometric.isAvailable();
    console.log('📱 biometricAuth: isAvailable result:', result);
    return result.isAvailable;
  } catch (error) {
    console.error('📱 biometricAuth: isAvailable error:', error);
    return false;
  }
};

export const getBiometryType = async () => {
  try {
    const result = await NativeBiometric.isAvailable();
    return result.biometryType || null;
  } catch {
    return null;
  }
};

export const authenticateWithBiometrics = async (reason = 'Please authenticate to access RE-BUILD-ME') => {
  try {
    console.log('📱 biometricAuth: 1. Checking biometrics availability...');
    const available = await isBiometricsAvailable();
    console.log('📱 biometricAuth: 2. Biometrics available:', available);
    if (!available) return { success: false, error: 'Biometrics not available', fallbackToPasscode: true };

    console.log('📱 biometricAuth: 3. Getting biometry type...');
    const biometryType = await getBiometryType();
    console.log('📱 biometricAuth: 4. Biometry type:', biometryType);

    console.log('📱 biometricAuth: 5. Calling verifyIdentity...');
    const result = await NativeBiometric.verifyIdentity({
      reason,
      title: 'RE-BUILD-ME',
      subtitle: biometryType === BiometryType.FACE_ID ? 'Sign in with Face ID' : 'Sign in with Touch ID',
      description: 'This will unlock your private journal.',
      useFallback: true,
      fallbackTitle: 'Use System Passcode', // This triggers the device passcode
    });
    console.log('📱 biometricAuth: 6. Biometric success', result);
    
    // If we get here, authentication was successful
    return { success: true };
    
  } catch (error) {
    console.error('📱 biometricAuth: 7. Biometric error:', error);
    
    // Check if the user tapped "Use System Passcode"
    if (error.message && error.message.includes('Fallback')) {
      console.log('📱 biometricAuth: User requested system passcode fallback');
      // The system will automatically show the device passcode screen
      // We just need to wait for that to complete
      return { success: false, error: 'fallback', shouldRetry: true };
    }
    
    // Check if user cancelled
    if (error.message && (error.message.includes('cancel') || error.message.includes('Cancel'))) {
      console.log('📱 biometricAuth: User cancelled');
      return { success: false, error: 'cancelled' };
    }
    
    // Other errors
    return { success: false, error: error.message };
  }
};

export default {
  isBiometricsAvailable,
  getBiometryType,
  authenticateWithBiometrics,
};